export enum UserDriverDownloadRequestOrder {
  FIRST_NAME_ASC = "FIRST_NAME_ASC",
  FIRST_NAME_DESC = "FIRST_NAME_DESC",
  LAST_NAME_ASC = "LAST_NAME_ASC",
  LAST_NAME_DESC = "LAST_NAME_DESC",
  TAXI_CORPORATION_DISPLAY_NAME_ASC = "TAXI_CORPORATION_DISPLAY_NAME_ASC",
  TAXI_CORPORATION_DISPLAY_NAME_DESC = "TAXI_CORPORATION_DISPLAY_NAME_DESC",
  LAST_PLAN_ENTRY_END_TIME_ASC = "LAST_PLAN_ENTRY_END_TIME_ASC",
  LAST_PLAN_ENTRY_END_TIME_DESC = "LAST_PLAN_ENTRY_END_TIME_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  MODIFIED_AT_ASC = "MODIFIED_AT_ASC",
  MODIFIED_AT_DESC = "MODIFIED_AT_DESC",
}

export enum UserDriverDownloadRequestStatusCriteria {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  ALL = "ALL",
}

export enum UserDriverDownloadRequestTimezone {
  EUROPE_WARSAW = "Europe/Warsaw",
  UTC = "UTC",
}

export type UserDriverDownloadRequestSeparatorTypes = ";" | ",";

export type UserDriverDownloadRequestQueryParams = {
  taxiCorporation?: string;
  taxiCorporationId?: string;
  fleetPartner?: string;
  fleetPartnerId?: string;
  address?: string;
  pendingCandidature?: boolean;
  order?: UserDriverDownloadRequestOrder;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserDriverDownloadRequestStatusCriteria;
  creationStart?: Date;
  creationEnd?: Date;
  modificationStart?: Date;
  modificationEnd?: Date;
  separator?: UserDriverDownloadRequestSeparatorTypes;
  timezone?: UserDriverDownloadRequestTimezone;
};

type UserDriverDownloadRequest = {
  taxiCorporation?: string;
  taxiCorporationId?: string;
  fleetPartner?: string;
  fleetPartnerId?: string;
  address?: string;
  pendingCandidature?: boolean;
  order?: UserDriverDownloadRequestOrder;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserDriverDownloadRequestStatusCriteria;
  creationStart?: Date;
  creationEnd?: Date;
  modificationStart?: Date;
  modificationEnd?: Date;
  separator?: UserDriverDownloadRequestSeparatorTypes;
  timezone?: UserDriverDownloadRequestTimezone;
};

export default UserDriverDownloadRequest;
